import { api } from './api-client'
import { getNativeFcmToken, isInNativeApp } from './nativeBridge'

/**
 * Register the device's FCM token against the logged-in member — the web-side equivalent of
 * fun88_mx_flutter's `UserApi.saveFcmToken`: `POST /fcm_token.php { type: 'store', fcm_token }`.
 *
 * The native lite app can't do this itself (it has no login session), so it exposes the token
 * via `window.Fun88Native.getFcmToken()` and the page POSTs it on the member's authenticated
 * session. The api-client request interceptor attaches `auth`/`username`/`password`, so this is
 * only meaningful once logged in (gated on `privateAuth`). It's a no-op on plain web (no native
 * bridge) or when the bridge can't supply a token, and errors are swallowed (best-effort, as in
 * the Flutter app). Calling it again always picks up the current token, so it also covers
 * token rotation when invoked on each login / session restore.
 */
export const syncFcmToken = async (): Promise<void> => {
  if (!isInNativeApp()) return
  if (!localStorage.getItem('privateAuth')) return
  try {
    const token = await getNativeFcmToken()
    if (!token) return
    await api.post('/fcm_token.php', { type: 'store', fcm_token: token })
  } catch {
    // best-effort; ignore bridge / network failures
  }
}
